import { render, staticRenderFns } from "./list03.vue?vue&type=template&id=4f98cb53&"
import script from "./list03.vue?vue&type=script&lang=js&"
export * from "./list03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports